import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import cn from 'classnames';
import { Button } from '@alfalab/core-components-button/esm';
import { transformSize } from './helpers/transformSize.js';

var defaultColors = {"primary":"icon-button__primary_uz27i","secondary":"icon-button__secondary_uz27i","transparent":"icon-button__transparent_uz27i","negative":"icon-button__negative_uz27i","tertiary":"icon-button__tertiary_uz27i","transparentBg":"icon-button__transparentBg_uz27i","component":"icon-button__component_uz27i","loader":"icon-button__loader_uz27i"};
require('./default.css')

var styles = {"border-24":"icon-button__border-24_1l97c","border-32":"icon-button__border-32_1l97c","border-40":"icon-button__border-40_1l97c","border-48":"icon-button__border-48_1l97c","border-56":"icon-button__border-56_1l97c","size-24":"icon-button__size-24_1l97c","size-32":"icon-button__size-32_1l97c","size-40":"icon-button__size-40_1l97c","size-48":"icon-button__size-48_1l97c","size-56":"icon-button__size-56_1l97c","iconWrapper":"icon-button__iconWrapper_1l97c","center":"icon-button__center_1l97c","left":"icon-button__left_1l97c","right":"icon-button__right_1l97c","icon":"icon-button__icon_1l97c"};
require('./index.css')

var invertedColors = {"primary":"icon-button__primary_r65jw","secondary":"icon-button__secondary_r65jw","transparent":"icon-button__transparent_r65jw","negative":"icon-button__negative_r65jw","tertiary":"icon-button__tertiary_r65jw","transparentBg":"icon-button__transparentBg_r65jw","component":"icon-button__component_r65jw","loader":"icon-button__loader_r65jw"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var SIZE_TO_CLASSNAME_MAP = {
    xxs: 'size-24',
    xs: 'size-32',
    s: 'size-48',
    24: 'size-24',
    32: 'size-32',
    40: 'size-40',
    48: 'size-48',
    56: 'size-56',
};
var IconButton = forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, Icon = _a.icon, _c = _a.view, view = _c === void 0 ? 'primary' : _c, _d = _a.size, size = _d === void 0 ? 48 : _d, _e = _a.colors, colors = _e === void 0 ? 'default' : _e, _f = _a.alignIcon, alignIcon = _f === void 0 ? 'center' : _f, _g = _a.transparentBg, transparentBg = _g === void 0 ? false : _g, restProps = __rest(_a, ["className", "icon", "view", "size", "colors", "alignIcon", "transparentBg"]);
    return (React.createElement(Button, __assign({}, restProps, { ref: ref, view: 'text', className: cn('cc-icon-button', className, colorStyles[colors][view], colorStyles[colors].component, styles["border-".concat(transformSize(size))], (_b = {},
            _b[colorStyles[colors].loader] = restProps.loading,
            _b[colorStyles[colors].transparentBg] = transparentBg,
            _b)), size: 's' }),
        React.createElement("span", { className: cn(styles.iconWrapper, styles[SIZE_TO_CLASSNAME_MAP[size]], styles[alignIcon]) }, React.isValidElement(Icon) ? (React.cloneElement(Icon, { className: cn(styles.icon, Icon.props.className) })) : (React.createElement(Icon, { className: styles.icon })))));
});
IconButton.displayName = 'IconButton';

export { IconButton };
